"use client";

import React, { useState, useEffect } from "react";
import { useAppContext } from "@components/Provider";

import Sites from "src/constants/Sites";
import Error404 from "@components/Error404/Error404";
import Login from "@components/Login/Login";
import Modal from "@components/Modal/Modal";
import ForgotPassword from "@components/ForgotPassword/ForgotPassword";
import { useSearchParams } from "next/navigation";
import { Post } from "src/services/ClientSideAPIService";
import { setCookie } from "helpers/Helper";
import { getUTMParams } from "helpers/Helper";

import styles from "./Login.module.css";

const LoginPage = () => {
  const { siteId, redirectPage } = useAppContext();
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const searchParams = useSearchParams();

  const { email, pid, redirect: redirectUrl } = Object.fromEntries(searchParams.entries());
  const { referral_source: utm_source } = getUTMParams(searchParams) || {};
  const [makeRedirect, setMakeRedirect] = useState(false);

  useEffect(() => {
    if (utm_source?.toLowerCase() === "sailthru" && email && pid && siteId) {
      const loginParam = {
        email,
        id: pid,
        siteid: siteId,
      };

      // Call the Post function
      Post(
        "LoginV2",
        { data: loginParam, siteId },
        (loginRes) => {
          const loginJson = loginRes;
          // console.log("Login response:", loginJson);

          // Set user cookies on login
          if (loginJson?.token) {
            const expiryDays = Number(process.env.SUBSCRIBED_COOKIE_EXPIRY_DAYS) || 30;
            setCookie("ormtoken", loginJson.token, expiryDays);
            setCookie("subscribed", email, expiryDays);
            setCookie("wasloggedin", "true", expiryDays); // Ensure it's a string

            setMakeRedirect(true);
          }
        },
        (err) => {
          console.error("Login error:", err);
        }
      );
    }
  }, [utm_source, email, pid, siteId]);

  useEffect(() => {
    if (makeRedirect) {
      window.location.href = redirectUrl || "/deals/best-ebook-deals"; // Redirect to the specified URL or a default one
    }
  }, [makeRedirect, redirectUrl]);

  return (
    <div className={[styles["loginPage"], "topPadding"].join(" ")}>
      {siteId === Sites.EARLYBIRDBOOKS ? (
        <Login
          redirectPage={redirectPage}
          openForgotPasswordModal={() => setIsForgotPasswordOpen(true)}
        />
      ) : (
        <Error404 isNewAppRouter={true} />
      )}
      <Modal
        className="ForgotPasswordModal"
        isOpen={isForgotPasswordOpen}
        closeBtn={() => setIsForgotPasswordOpen(false)}
        sizeClass="small"
      >
        <ForgotPassword />
      </Modal>
    </div>
  );
};

export default LoginPage;
